import React, { useContext, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { connect, useDispatch } from 'react-redux';
import { addMapMode, removeMapMode } from 'client/store/mapSlice/mapSlice';
import PropTypes from 'prop-types';
import { MapContext } from 'os-elements';
import Button from 'client/components/GDS/Button/Button';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';
import { mapModes } from 'client/utils/constants/appStates';
import { VALID_MODES } from './CloseButton.mode';
import mapModeIsValid from '../validateModes';
import { clearDrawStatus } from 'client/store/drawSlice/drawSlice';
import { setAlertOpen } from 'client/store/alertSlice/alertSlice';

const { DEFAULT, DRAWING, MODIFYING } = mapModes;

const CloseButton = ({
    mapMode,
    addMapMode,
    removeMapMode
}) => {
    const intl = useIntl();
    const { map } = useContext(MapContext);
    const dispatch = useDispatch();

    const handleClose = () => {
        addMapMode(DEFAULT);
        removeMapMode(MODIFYING);
        const drawSource = map?.getLayerById('draw')?.getSource();
        drawSource?.clear();
        removeMapMode(DRAWING);
        // assume that if the cancel button appears, then there must have been a valid
        // aoi beforehand, so we can remove the alert without clearing the status
        dispatch(setAlertOpen(false));
    };

    // Clean up when unmounted e.g. user navigates to another page
    useEffect(() => handleClose, []);

    return mapModeIsValid(mapMode, VALID_MODES)
        ? <Button
            data-testid="mapToolBar.draw.close"
            variant="error"
            onClick={handleClose}
        >
            <Icon path={mdiClose} size={0.7}/>
            { intl.formatMessage({ id: 'general.cancel' }) }
        </Button>
        : null;
};

CloseButton.propTypes = {
    mapMode: PropTypes.array,
    addMapMode: PropTypes.func,
    removeMapMode: PropTypes.func,
    clearDrawStatus: PropTypes.func
};

const mapStateToProps = state => {
    const { map } = state;
    return {
        mapMode: map?.mode || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        addMapMode: (payload) => dispatch(addMapMode(payload)),
        removeMapMode: (payload) => dispatch(removeMapMode(payload)),
        clearDrawStatus: (payload) => dispatch(clearDrawStatus(payload))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CloseButton);
